import { Component, OnInit, OnChanges } from '@angular/core';
import { PageComponent } from '../page/page.component';
import { GlobalsService } from '../../services/globals.service';
import { StorageService } from '../../services/storage.service';
import { ViasConnectionService, ViasResponse } from '../../services/vias-connection.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageMeta } from '../../services/page-meta.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vias-default-master-detail-page',
  templateUrl: '../page/page.component.html',
  styleUrls: ['../page/page.component.scss']
})
export class DefaultMasterDetailPageComponent extends PageComponent {

  constructor(
    protected storage: StorageService,
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected next: ActivatedRoute,
    protected route: Router,
    protected translate: TranslateService
  ) {
    super(storage, globals, viasService, next, route, translate);
    this.hasDatagrid = true;
    this.hasEditForm = true;
  }


  generatePageFromMeta(pageMeta: PageMeta) {
    super.generatePageFromMeta(pageMeta);
    this.aid = pageMeta.listAid;
    this.hasButtonbar = pageMeta.hasButtonBarInList;
    console.log(pageMeta);
    this.refreshData();
  }

  viasServiceHandler(r: ViasResponse) {
    console.log(r);
    console.log('------cevap geldi');
    if (r.data) {
      console.log(r.data);
      if (r.data['duty_code']) {
        this.dataSource = r.data['duty_code'];
      }
      if (r.data['total_page']) {
        this.totalPages = r.data['total_page'];
      }
      if (r.data['page_no']) {
        this.pageno = r.data['page_no'];
      }
    }
  }
}
